import { getQueryParams } from '@perch-labs/warbler';
import { apolloClient } from '~/apollo-client';
import {
  Flex_UpdateUtilityCredentialMutation,
  Flex_UpdateUtilityCredentialMutationVariables,
} from '~/typings/graphql';
import { amerenRedirectUrl } from '~/utils/redirects';
import { UPDATE_UTILITY_CREDENTIAL } from './update-utility-credential.queries';

export interface UpdateAmerenCredentialParams {
  amerenCode: string;
  utilityCredentialId: number;
}

export interface UpdateAmerenCredentialResponse {
  verificationStatus?: string;
}

export const updateAmerenCredential = async (
  params: UpdateAmerenCredentialParams,
): Promise<UpdateAmerenCredentialResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_UpdateUtilityCredentialMutation,
    Flex_UpdateUtilityCredentialMutationVariables
  >({
    mutation: UPDATE_UTILITY_CREDENTIAL,
    variables: {
      id: params.utilityCredentialId,
      input: {
        password: params.amerenCode,
        redirectUri: getQueryParams(amerenRedirectUrl()).redirect_uri as string,
      },
    },
  });

  const verificationStatus = data?.updateUtilityCredential.verificationStatus;
  if (verificationStatus === 'incorrect') throw new Error('Incorrect credentials');

  return { verificationStatus };
};
